import {Component, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {MapService} from '../../core/map/map.service';
import {AccountsService} from '../../core/accounts/accounts.service';
import {RoutesService} from '../../core/routes/routes.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {FieldsService} from '../../core/fields/fields.service';

@Component({
  selector: 'app-lasso',
  templateUrl: './lasso.component.html',
  styleUrls: ['./lasso.component.scss'],
  host: {
    '(document:mousedown)': 'onClick($event)'
  }
})
export class LassoComponent implements OnInit {

  @Output() close = new EventEmitter();

  @ViewChild('popover') popover;

  showPopup: boolean;

  lassoMode: boolean;

  selectedAccounts: any[];

  massUpdateModalRef: BsModalRef;

  fields: any[];

  fieldValues: any[] = [];

  constructor(public mapService: MapService,
              private accountsService: AccountsService,
              private routesService: RoutesService,
              private fieldsService: FieldsService,
              private modalService: BsModalService) { }

  ngOnInit() {
    this.mapService.completeLasso
      .subscribe((accounts: any[]) => {
        if (accounts) {
          this.selectedAccounts = accounts;
          this.lassoMode = false;
        }
      });

    this.accountsService.deleteAccount
      .subscribe(id => {
        if (id && this.selectedAccounts && this.selectedAccounts.length) {
          this.selectedAccounts = this.selectedAccounts.filter(a => {
            return a._id !== id;
          });
        }
      });

    this.fieldsService.listFieldValues()
      .subscribe((fields: any[]) => {
        this.fields = fields;
      });
  }

  private onClick(event): void {
    if (this.showPopup
      && (
        !this.popover._popover
        || !this.popover._popover._componentRef
        || !this.popover._popover._componentRef.location
        || !this.popover._popover._componentRef.location.nativeElement
        || !this.popover._popover._componentRef.location.nativeElement.contains(event.target)
      )
    ) {
      this.hide();
    }
  }

  hide() {
    this.showPopup = false;
    this.popover.hide();
  }

  show() {
    this.showPopup = true;
    this.popover.show();
  }

  bulkDelete(selectedAccounts) {
    this.accountsService.bulkDelete(selectedAccounts.map(a => a._id));
    this.showPopup = false;
  }

  clear() {
    this.mapService.clearLassoSelection();
    this.selectedAccounts = [];
  }

  createRoute(selectedAccounts) {
    this.routesService.createNewRoute(selectedAccounts);
  }

  deleteAccount(account) {
    this.selectedAccounts = this.selectedAccounts.filter(a => account._id !== a._id);
    this.mapService.deleteFromLasso(account._id);
  }

  toggleLasso(draw?: boolean) {
    this.mapService.toggleLasso();
    this.selectedAccounts = [];
  }

  onAdd(fieldValue) {
    this.fieldValues.push(fieldValue);
  }

  selectAccount(e, account) {
    this.accountsService.select(account);
    e.preventDefault();
  }

  openMassUpdateModal(template) {
    this.massUpdateModalRef = this.modalService.show(template);
  }

  closeModal() {
    this.massUpdateModalRef.hide();
    this.fieldValues = [];
  }

  update() {
    this.accountsService.bulkEditCustomFields(this.selectedAccounts.map(a => a._id), this.fieldValues)
      .subscribe(() => {
        this.massUpdateModalRef.hide();
        this.fieldValues = [];
      });
  }

  isActive(account) {
    return this.accountsService.selectedAccount === account;
  }

}



// WEBPACK FOOTER //
// ./client/app/components/lasso/lasso.component.ts